import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { isin } from './validator';

@Directive({
    selector: '[isin][formControlName],[isin][formControl],[isin][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => IsinValidatorDirective),
            multi: true,
        },
    ],
})
export class IsinValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = isin();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
